// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"743":"e8d20f54","749":"e603738c"}[chunkId] + ".chunk.css";
};